/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  // Signature Required Logic
  // ========================
  document.addEventListener('DOMContentLoaded', function () {
    const signatureName = 'attributes[signature_required_QWEKUK]';

    function getCartForm() {
      return document.querySelector('form#cartForm');
    }

    function getCheckoutBtn() {
      return document.querySelector('button[name="checkout"]');
    }

    function getSignatureInputs() {
      return document.querySelectorAll(`input[name="${signatureName}"]`);
    }

    function isSignatureSelected() {
      return Array.from(getSignatureInputs()).some(input => input.checked);
    }

    function updateCheckoutButtonState() {
      const checkoutBtn = getCheckoutBtn();
      const summaryTitle = document.querySelector('summary.signature-required-label');
      const errorEl = document.getElementById('signature-error');

      if (!checkoutBtn) return;

      if (isSignatureSelected()) {
        checkoutBtn.disabled = false;
        checkoutBtn.removeAttribute('data-tooltip');
        checkoutBtn.style.cursor = '';
        summaryTitle?.classList.remove('signature-error');
        errorEl?.style.setProperty('display', 'none');
      } else {
        checkoutBtn.disabled = true;
        checkoutBtn.setAttribute('data-tooltip', 'select a signature option above to continue');
        checkoutBtn.style.cursor = 'not-allowed';
        summaryTitle?.classList.add('signature-error');
        errorEl?.style.setProperty('display', 'block');
      }
    }

    function handleSignatureChange() {
      const form = getCartForm();
      if (!form) return;

      const formData = new FormData(form);

      fetch('/cart/update.js', {
        method: 'POST',
        body: formData,
      })
        .then(() => {
          setTimeout(updateCheckoutButtonState, 50);
        })
        .catch(err => {
          console.error('Cart update failed', err);
        });
    }

    function attachListeners() {
      getSignatureInputs().forEach(input => {
        input.removeEventListener('change', handleSignatureChange);
        input.addEventListener('change', handleSignatureChange);
      });

      const form = getCartForm();
      if (form) {
        form.addEventListener('submit', function (e) {
          if (!isSignatureSelected()) {
            e.preventDefault();
            updateCheckoutButtonState();
          }
        });
      }

      updateCheckoutButtonState();
    }

    const observer = new MutationObserver(() => {
      attachListeners();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    attachListeners();
  });

  // ========================
  // Price Doubling Logic
  // ========================
  document.addEventListener('DOMContentLoaded', function () {
    function updatePriceDisplay(price) {
      let priceElement = document.getElementById('priceDisplay');
      let retailPriceElement = document.querySelector('[data-product-price]');

      if (priceElement && retailPriceElement) {
        priceElement.innerText = '$' + price.toFixed(2);
        retailPriceElement.innerText = '$' + (price * 2).toFixed(2);
      }
    }

    function updatePriceOnVariantChange() {
      document.addEventListener('variant:change', function (event) {
        let newVariant = event.detail.variant;
        if (newVariant) {
          updatePriceDisplay(newVariant.price / 100);
        }
      });
    }

    let initialPriceElement = document.querySelector('[data-product-price]');
    if (initialPriceElement) {
      let initialPrice = parseFloat(initialPriceElement.innerText.replace(/[^0-9.]/g, ''));
      updatePriceDisplay(initialPrice);
    }

    updatePriceOnVariantChange();
  });

  // ========================
  // Mobile Tabs Behavior
  // ========================
  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth <= 768) {
      const tabLinks = document.querySelectorAll('.product-tabs .tab-link');
      const tabContents = document.querySelectorAll('.product-tabs .tab-content:not(.static-content)');

      tabLinks.forEach(link => {
        link.classList.remove('current');
        const icon = link.querySelector('.tab-toggle-icon');
        if (icon) icon.textContent = '+';
      });
      tabContents.forEach(content => {
        content.classList.remove('current', 'mobile-open');
      });

      tabLinks.forEach((link, index) => {
        link.addEventListener('click', () => {
          const content = tabContents[index];
          const isOpen = content.classList.contains('mobile-open');

          if (isOpen) {
            content.classList.remove('mobile-open', 'current');
            link.classList.remove('current');
            const icon = link.querySelector('.tab-toggle-icon');
            if (icon) icon.textContent = '+';
          } else {
            tabContents.forEach(c => c.classList.remove('mobile-open', 'current'));
            tabLinks.forEach(l => {
              l.classList.remove('current');
              const icon = l.querySelector('.tab-toggle-icon');
              if (icon) icon.textContent = '+';
            });

            content.classList.add('mobile-open', 'current');
            link.classList.add('current');
            const icon = link.querySelector('.tab-toggle-icon');
            if (icon) icon.textContent = '–';
          }
        });
      });
    }
  });

  // ========================
  // Variant Change Refresh Logic
  // ========================
  document.addEventListener('DOMContentLoaded', function () {
    let currentVariant = new URLSearchParams(window.location.search).get('variant');

    const observer = new MutationObserver(() => {
      const newVariant = new URLSearchParams(window.location.search).get('variant');
      if (newVariant && newVariant !== currentVariant) {
        currentVariant = newVariant;
        window.location.href = `${window.location.pathname}?variant=${newVariant}`;
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    const checkForVariantChange = () => {
      const newVariant = new URLSearchParams(window.location.search).get('variant');
      if (newVariant && newVariant !== currentVariant) {
        currentVariant = newVariant;
        window.location.href = `${window.location.pathname}?variant=${newVariant}`;
      }
    };

    history.pushState = function () {
      originalPushState.apply(this, arguments);
      checkForVariantChange();
    };

    history.replaceState = function () {
      originalReplaceState.apply(this, arguments);
      checkForVariantChange();
    };

    window.addEventListener('popstate', checkForVariantChange);
  });
})();

document.addEventListener('DOMContentLoaded', function () {
  const engravingForm = document.querySelector('#engraving-form');
  const engravingOption = document.querySelector('input[value="WITH ENGRAVING"]');
  const withoutEngravingOption = document.querySelector('input[value="WITHOUT ENGRAVING"]');
  const engravingText = document.querySelector('#engraving-text');
  const engravingFontRadios = document.querySelectorAll('input[name="properties[Engraving Font]"]');

  function changeFont() {
    if (!engravingText) return;

    engravingText.classList.remove('dancing-script', 'raleway');

    const selectedFont = document.querySelector('input[name="properties[Engraving Font]"]:checked');
    if (selectedFont) {
      const value = selectedFont.value;

      if (value === 'Font Option 1 - Script') {
        engravingText.classList.add('dancing-script');
      } else if (value === 'Font Option 2 - Regular') {
        engravingText.classList.add('raleway');
      }
    }
  }

  const checkEngravingOption = function () {
    if (engravingOption && engravingOption.checked) {
      if (engravingForm) engravingForm.style.display = 'block';
    } else {
      if (engravingForm) engravingForm.style.display = 'none';
    }
  };

  // Event listeners
  if (engravingOption) {
    engravingOption.addEventListener('change', checkEngravingOption);
  }

  if (withoutEngravingOption) {
    withoutEngravingOption.addEventListener('change', checkEngravingOption);
  }

  engravingFontRadios.forEach((radio) => {
    radio.addEventListener('change', changeFont);
  });

  // On page load
  checkEngravingOption();
  changeFont();
});

document.addEventListener('theme:recently-viewed:loaded', function() {
  const sliders = document.querySelectorAll('[data-hover-slider]');
  sliders.forEach(slider => {
    if (!slider.classList.contains('flickity-enabled')) {
      new Flickity(slider, {
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        prevNextButtons: true,
        pageDots: false,
        draggable: false,
        fade: true
      });
    }
  });
});
